import { gql } from 'graphql-tag'
import { addressFields } from '../addressFields'

export const UPDATE_CLIENT_ADDRESS_INSTRUCTIONS = gql`
  mutation updateClientAddressInstructions(
    $clientId: ID!
    $addressId: ID!
    $updateInstructionsInput: UpdateInstructionsInput!
  ) {
    updateClientAddressInstructions(
      clientId: $clientId
      addressId: $addressId
      updateInstructionsInput: $updateInstructionsInput
    ) {
      ...AddressFields
    }
  }
  ${addressFields}
`
